import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { SafeAreaService } from '../../@services/webview/safe-area.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'vw-header-padding-safe-area',
    imports: [
        NgClass
    ],
    templateUrl: './header-padding-safe-area.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-padding-safe-area.component.scss'
})
export class HeaderPaddingSafeAreaComponent implements OnInit, OnDestroy {
  @Input() look: 'primary' | 'light' | 'white' = 'light'
  @Input() withScroll: boolean = false;

  private safeAreaSubscription?: Subscription;
  safeAreaTop = 64;

  constructor(private safeAreaService: SafeAreaService) { }

  ngOnInit() {
    // Subscribe to safe area data changes
    this.safeAreaSubscription = this.safeAreaService.safeAreaData$.subscribe(data => {
      this.safeAreaTop = data.top || 64;
    });
  }

  ngOnDestroy() {
    // Clean up subscription
    if (this.safeAreaSubscription) {
      this.safeAreaSubscription.unsubscribe();
    }
  }
}
